import { CartAddEvent, CartPendingUpdateEvent, nextCartPendingToken } from '@theme/events';

// Scroll navigation handler
document.addEventListener('click', (event) => {
  const prevBtn = event.target.closest('.cart-frequently-bought__arrow--prev');
  const nextBtn = event.target.closest('.cart-frequently-bought__arrow--next');
  if (!prevBtn && !nextBtn) return;

  const container = (prevBtn || nextBtn).closest('.cart-frequently-bought');
  const carousel = container?.querySelector('.cart-frequently-bought__carousel');
  if (!carousel) return;

  const scrollAmount = 240;
  carousel.scrollBy({ left: prevBtn ? -scrollAmount : scrollAmount, behavior: 'smooth' });
});

// Swaps the plus icon for a spinner while the add request is in flight.
// `data-loading` drives the visuals in CSS, matching the PDP sticky bar.
function setLoading(button, isLoading) {
  button.disabled = isLoading;
  if (isLoading) {
    button.dataset.loading = 'true';
    button.setAttribute('aria-busy', 'true');
  } else {
    delete button.dataset.loading;
    button.removeAttribute('aria-busy');
  }
}

// Quick add-to-cart handler
document.addEventListener('click', async (event) => {
  const addBtn = event.target.closest('.cart-frequently-bought__add-btn');
  if (!addBtn || addBtn.disabled) return;

  const variantId = addBtn.dataset.variantId;
  if (!variantId) return;

  const cartItemsComponent = addBtn.closest('cart-items-component') || document.querySelector('cart-items-component');
  const sectionId = cartItemsComponent?.dataset.sectionId;

  setLoading(addBtn, true);

  // Bump the cart bubble straight away; the add request and the cart
  // re-fetch behind it settle the count once they land.
  const pendingToken = nextCartPendingToken();
  document.dispatchEvent(new CartPendingUpdateEvent(1, pendingToken));

  let settled = false;
  const rollback = () => {
    if (settled) return;
    settled = true;
    document.dispatchEvent(
      new CartAddEvent({}, variantId, {
        didError: true,
        source: 'cart-frequently-bought',
        itemCount: 1,
        variantId: variantId,
        token: pendingToken,
      })
    );
  };

  try {
    const bodyData = {
      id: variantId,
      quantity: 1,
    };
    if (sectionId) {
      bodyData.sections = sectionId;
      bodyData.sections_url = window.location.pathname;
    }

    const cartAddUrl =
      window.Theme?.routes?.cart_add_url ||
      (window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js');

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(bodyData),
    });

    const result = await response.json();

    if (!response.ok || result.errors) {
      console.error('Cart add error:', result.errors || result);
      rollback();
      return;
    }

    const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
    const cart = await cartResponse.json();

    settled = true;
    document.dispatchEvent(
      new CartAddEvent(cart, variantId, {
        source: 'cart-frequently-bought',
        itemCount: cart.item_count,
        variantId: variantId,
        sections: result.sections,
        token: pendingToken,
      })
    );
  } catch (error) {
    console.error('Failed to add upsell item to cart:', error);
    rollback();
  } finally {
    // A successful add re-renders the drawer, which drops this card (the
    // product is in the cart now), so the button is often already detached
    // by this point — resetting it anyway keeps the error paths correct.
    setLoading(addBtn, false);
  }
});
